/**
 * Plugin to mark the navbar as attached if the window is not scrolled,
 * or as _detached otherwise
 */
export default class DetachNavbar {
    constructor(navbar, offset = 0) {
        if (typeof jQuery === 'undefined') {
            throw new ReferenceError('jQuery is required');
        }
        const scroll = this.scroll = this.scroll.bind(this);
        this.navbar = jQuery(navbar);
        this.offset = offset;
        this._detached = undefined;

        jQuery(window).scroll(scroll);

        // Init
        scroll();
    }

    get detached() {
        return this._detached;
    }

    scroll() {
        const _detached = this._detached;
        if (jQuery(window).scrollTop() <= this.offset) {
            if (_detached !== false) {
                this._detached = false;
                this.navbar.addClass('attached').removeClass('detached');
            }
        } else if (_detached !== true) {
            this.navbar.addClass('detached').removeClass('attached');
            this._detached = true;
        }
    }
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/Ui/DetachNavbar.js